import { observer } from 'mobx-react-lite';
import { calendarsUnavailableDismissLabel } from './CalendarLoadError.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import {
    getRefreshSuggestionMessage,
    getPrimaryErrorMessage,
    FailureType,
} from 'owa-calendar-load-error-message';
import setLoadFailureDialogState from '../mutators/setLoadFailureDialogState';
import getStore from '../store';

const styles = require('./CalendarLoadError.scss');

export default observer(function CalendarLoadError(props: {}) {
    const { loadFailureHidden, failureState } = getStore();
    return (
        <Dialog
            hidden={loadFailureHidden}
            onDismiss={closeErrorDialog}
            dialogContentProps={{
                type: DialogType.normal,
                title: getPrimaryErrorMessage(),
                subText: getRefreshSuggestionMessage(
                    failureState === 'Throttled' ? FailureType.Throttled : FailureType.Failed
                ),
            }}
            modalProps={{ isBlocking: false }}
            styles={{ main: styles.errorModal }}>
            <DialogFooter>
                <PrimaryButton
                    onClick={closeErrorDialog}
                    text={loc(calendarsUnavailableDismissLabel)}
                />
            </DialogFooter>
        </Dialog>
    );
});

function closeErrorDialog() {
    setLoadFailureDialogState(true);
}
